var $ = require('jquery');
var basePage = require('../pages/base-page.js');
var financeWidget = require('../components/finance-widget');
var config = require('../utils/config.js');
var timer = require('../utils/timer');
var layout = require('../ui/layout');
var motorwayWidget = require('../components/motorway-widget.js');
var analytics = require('../utils/analytics.js');
var scrolling = require('../ui/scroll.js');

var classNames = {
	active: 'active',
	cancelRotation: 'cancel-rotation',
	closeLink: 'close-link',
	container: 'container',
	info: 'info',
	icon: 'icon',
	tabs: 'tabs',
	tab: 'tab',
	text: 'text',
	valuationPriceBox: 'valuation-price-box',
	valuationFreePage: 'valuation-free-page',
	valuationOptionBox: 'valuation-option-box',
	comparePricesLink: 'compare-prices-link',
	animationContainer: 'animation-container'
};

var modifiers = {
	nextSteps: 'next-steps'
};

var switchTabFunction;
var cancelRotationClickEvent = 'click.cancel-rotate';

// this works on the assumption the content panels will be positioned in the same order as their respective tabs.
// no reason they shouldn't be otherwise.
function setActiveTab(tabComponents, nextActiveTabIndex) {
	$(tabComponents.switchableTabs).removeClass(classNames.active);
	$(tabComponents.switchableTabs[nextActiveTabIndex]).addClass(classNames.active);
	$(tabComponents.switchableTabPanels).removeClass(classNames.active);
	$(tabComponents.switchableTabPanels[nextActiveTabIndex]).addClass(classNames.active);
}

function getNextActiveTabIndex(tabComponents) {
	var result = 0;
	var tabCount = tabComponents.switchableTabs.length;

	for (var tabIndex = 0; tabIndex < tabCount; tabIndex++) {
		var tab = tabComponents.switchableTabs[tabIndex];
		if ($(tab).hasClass(classNames.active)) {
			result = tabIndex === tabCount - 1 ? 0 : tabIndex + 1;
		}
	}

	return result;
}

function startCycleTimer(tabComponents) {
	switchTabFunction = timer.begin(function () {
		var nextActiveTabIndex = getNextActiveTabIndex(tabComponents);
		setActiveTab(tabComponents, nextActiveTabIndex);
		startCycleTimer(tabComponents);
	}, tabComponents.cycleDuration);
}

function initTabAutoRotate(context) {
	var cycleDurationDefault = 5000;
	var $valuationContainer = $(context).findByBem(classNames.valuationFreePage, classNames.container).first();
	var $switchableTabs = $valuationContainer.findByBem(classNames.valuationFreePage, classNames.tabs).find('.tab');

	var tabComponents = {
		switchableTabs: $switchableTabs,
		switchableTabPanels: $valuationContainer.find('.tab-content'),
		cycleDuration: $($switchableTabs).parentsByBem(classNames.valuationFreePage, classNames.tabs).data('cycle-duration') * 1000
	};

	if (tabComponents.cycleDuration === 0) {
		tabComponents.cycleDuration = cycleDurationDefault;
	}

	startCycleTimer(tabComponents);

	// stop auto-rotate when a cancel-rotation marked element is clicked.
	var cancelRotationElements = $valuationContainer.find('.' + classNames.cancelRotation);
	cancelRotationElements.on(cancelRotationClickEvent, function () {
		timer.cancel(switchTabFunction);
		cancelRotationElements.unbind(cancelRotationClickEvent);
	});
}

function togglePriceBoxes(priceBox) {
	var iconCloseClass = $.getBemClass(classNames.valuationPriceBox, classNames.icon, 'close');
	$(priceBox).toggleClass(iconCloseClass);
	$(priceBox).parent().siblingsByBem(classNames.valuationPriceBox, classNames.info).slideToggle('fast');
}

function initInfoToggle(context) {
	$.findByBem(classNames.valuationPriceBox, classNames.icon, null, context).on('click', function () {
		var priceBox = this;
		togglePriceBoxes(priceBox);

		$(priceBox).parent()
			.siblingsByBem(classNames.valuationPriceBox, classNames.info)
			.childrenByBem(classNames.valuationPriceBox, classNames.closeLink)
			.unbind('click')
			.on('click', function () {
				togglePriceBoxes(priceBox);
			});
	});
}

function initNextStepsTracking() {
	$.findByBem(classNames.tab, null, modifiers.nextSteps).on('click.nextsteps', function () {
		var tabName = $(this).findByBem(classNames.tab, classNames.text).text();
		analytics.trackEvent('Valuation next steps tab', 'Tab click', tabName);
	});
}

function initMotorwayScrollClick() {
	$.findByBem(classNames.valuationOptionBox, classNames.comparePricesLink).on('click', function () {
		analytics.trackEvent('Motorway anchor link', 'Click', config.dataLayer.page.templateName);
		scrolling.scrollTo($('.compare-prices-click-target'), 10);
	});
}

function initAnimationClick() {
	$.findByBem(classNames.valuationFreePage, classNames.animationContainer).on('click', function() {
		analytics.trackEvent('Valuation Animation', 'Click', layout.getScreenSize());
	});
}

basePage.init = function () {
	var $context = $('#valuationDetailFreePage');

	basePage.initBasePage();
	financeWidget.init($context);
	motorwayWidget.init(false);
	initInfoToggle($context);
	initNextStepsTracking();
	initMotorwayScrollClick();
	initAnimationClick();

	if (layout.isMobile()) {
		initTabAutoRotate($context);
	}
};

module.exports = basePage;